import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const ShowMoreDotsIcon = createIcon({
    viewBox: '0 0 24 24',
    path: (
        <>
            <Path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M12 15.584C12.544 15.584 13.016 15.784 13.416 16.184C13.816 16.584 14.016 17.056 14.016 17.6C14.016 18.144 13.816 18.616 13.416 19.016C13.016 19.416 12.544 19.616 12 19.616C11.456 19.616 10.984 19.416 10.584 19.016C10.184 18.616 9.98401 18.144 9.98401 17.6C9.98401 17.056 10.184 16.584 10.584 16.184C10.984 15.784 11.456 15.584 12 15.584ZM12 9.58401C12.544 9.58401 13.016 9.78401 13.416 10.184C13.816 10.584 14.016 11.056 14.016 11.6C14.016 12.144 13.816 12.616 13.416 13.016C13.016 13.416 12.544 13.616 12 13.616C11.456 13.616 10.984 13.416 10.584 13.016C10.184 12.616 9.98401 12.144 9.98401 11.6C9.98401 11.056 10.184 10.584 10.584 10.184C10.984 9.78401 11.456 9.58401 12 9.58401ZM12 7.61601C11.456 7.61601 10.984 7.41602 10.584 7.01601C10.184 6.61601 9.98401 6.14402 9.98401 5.60001C9.98401 5.05601 10.184 4.58401 10.584 4.18401C10.984 3.78401 11.456 3.58401 12 3.58401C12.544 3.58401 13.016 3.78401 13.416 4.18401C13.816 4.58401 14.016 5.05601 14.016 5.60001C14.016 6.14402 13.816 6.61601 13.416 7.01601C13.016 7.41602 12.544 7.61601 12 7.61601Z'
                fill='currentColor'
            />
        </>
    ),
})

ShowMoreDotsIcon.displayName = 'ShowMoreDotsIcon'
